/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalItemList_data = {
    readonly externalItemList: {
        readonly items: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly slug: string;
                    readonly " $fragmentRefs": FragmentRefs<"ExternalListPageItem_listItem">;
                } | null;
            } | null> | null;
            readonly pageInfo: {
                readonly hasNextPage: boolean;
                readonly endCursor: string | null;
            };
        };
    };
    readonly " $refType": "ExternalItemList_data";
};
export type ExternalItemList_data$data = ExternalItemList_data;
export type ExternalItemList_data$key = {
    readonly " $data"?: ExternalItemList_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalItemList_data">;
};



const node: ReaderFragment = (function(){
var v0 = [
  "externalItemList",
  "items"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "dischargeDateEnd"
    },
    {
      "kind": "RootArgument",
      "name": "dischargeDateStart"
    },
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "kind": "RootArgument",
      "name": "includeArchived"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "perPage"
    },
    {
      "kind": "RootArgument",
      "name": "searchQuery"
    },
    {
      "kind": "RootArgument",
      "name": "showFilters"
    },
    {
      "kind": "RootArgument",
      "name": "sortKey"
    },
    {
      "kind": "RootArgument",
      "name": "type"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtaEnd"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtaStart"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtdEnd"
    },
    {
      "kind": "RootArgument",
      "name": "voyageEtdStart"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ExternalItemListPaginationQuery.graphql.ts')
    }
  },
  "name": "ExternalItemList_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dischargeDateEnd",
          "variableName": "dischargeDateEnd"
        },
        {
          "kind": "Variable",
          "name": "dischargeDateStart",
          "variableName": "dischargeDateStart"
        },
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Variable",
          "name": "includeArchived",
          "variableName": "includeArchived"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "perPage",
          "variableName": "perPage"
        },
        {
          "kind": "Variable",
          "name": "searchQuery",
          "variableName": "searchQuery"
        },
        {
          "kind": "Variable",
          "name": "showFilters",
          "variableName": "showFilters"
        },
        {
          "kind": "Variable",
          "name": "sortKey",
          "variableName": "sortKey"
        },
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "type"
        },
        {
          "kind": "Variable",
          "name": "voyageEtaEnd",
          "variableName": "voyageEtaEnd"
        },
        {
          "kind": "Variable",
          "name": "voyageEtaStart",
          "variableName": "voyageEtaStart"
        },
        {
          "kind": "Variable",
          "name": "voyageEtdEnd",
          "variableName": "voyageEtdEnd"
        },
        {
          "kind": "Variable",
          "name": "voyageEtdStart",
          "variableName": "voyageEtdStart"
        }
      ],
      "concreteType": "ExternalItemList",
      "kind": "LinkedField",
      "name": "externalItemList",
      "plural": false,
      "selections": [
        {
          "alias": "items",
          "args": null,
          "concreteType": "ExternalListItemConnection",
          "kind": "LinkedField",
          "name": "__ItemList_itemList_items_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExternalListItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExternalListItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ExternalListPageItem_listItem"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApplicationQuery",
  "abstractKey": null
};
})();
(node as any).hash = 'f1bc5c9fff581ad18f9b7b7de6cc3cb9';
export default node;
